import React from 'react';

import Similarity from 'views/Meteorology/Weather/Similarity';

const similarityRouter = {
  path: 'similarity',
  element: <Similarity />,
};

export default similarityRouter;
